<template>
      <div class="honor">
        <div class="w">
            <div class="honor_w">
                <div class="iconLeft">
                    <van-image
                        width="100%"
                        height="100%"
                        :src="leftIcon"
                        @click="leftIconClick"
                    />
                </div>
                <div class="iconRight">
                    <van-image
                        width="100%"
                        height="100%"
                        :src="rightIcon"
                        @click="rightIconClick"
                    />
                </div>
                <div class="honorCenter" ref="honorCenter">
                    <div class="li" v-for="(item , index) in honorData" :key="index">
                        <van-image
                            width="100%"
                            height="247px"
                            :src="item.url"
                        />
                        <div class="title">{{item.title}}</div>
                        <p class="contentWord">{{item.note}}</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
export default {
  data(){
    return{
      leftIcon:require('../assets/arrows03.png'),
      leftIconFocus:require('../assets/arrows04.png'),
      rightIcon:require('../assets/arrows01.png'),
      rightIconFocus:require('../assets/arrows02.png'),
      honorData:[
                {
                    url:"http://banner.joymido.com/web_mobile_honor01.png",
                    title:"『音乐教育科技产业园正式授牌』",
                    note:'上音佳音携手，沪连合作迈向新阶段 音乐科技融合，互联资源拓展新业态'
                },
                {
                    url:"http://banner.joymido.com/web_mobile_honor02.png",
                    title:"『发明创业奖·项目奖』",
                    note:'荣获2016年第九届国际发明展览会 "发明创业奖·项目奖"一金一银一铜三项大奖'
                },
                {
                    url:"http://banner.joymido.com/web_mobile_honor04.png",
                    title:"『音乐社会教育远程培训中心授牌』",
                    note:'造互联教育新业态 谱写沪连合作新乐章'
                },
                {
                    url:"http://banner.joymido.com/web_mobile_honor05.png",
                    title:"『权威机构推荐』",
                    note:'中央音乐学院、中国音乐学院等高等院校推荐的指定钢琴课后陪练服务。'
                },
                {
                    url:"http://banner.joymido.com/web_mobile_honor06.png",
                    title:"『中国设计红星奖·最受大众喜爱奖』",
                    note:'荣膺2016年"中国设计红星奖"、 "中国设计红星奖·最受大众喜爱奖"两项殊荣'
                },
                {
                    url:"http://banner.joymido.com/web_mobile_honor07.png",
                    title:"『多项知识产权』",
                    note:'项目所囊括的全部系列产品已斩获众多专业领域知识产权和荣誉'
                },
            ],
            honorIndex:0
    }
  },
  methods:{
    leftIconClick(){
      console.log(this.honorIndex)
      if(this.honorIndex > 0){
        this.honorIndex = this.honorIndex - 1
        let scrollLeft = this.$refs.honorCenter.scrollLeft
        let scrollTo = this.honorIndex*475
        console.log(scrollLeft)
        console.log(scrollTo)
        var timer = setInterval(()=>{
            if(scrollLeft > scrollTo){
              console.log(scrollLeft)
              scrollLeft = scrollLeft-10
              this.$refs.honorCenter.scrollLeft = scrollLeft
            }else{
              console.log('停止')
              clearInterval(timer)
            }
        },1);
      }else {
        console.log('第一张')
      }
      
    },
    rightIconClick(){
      // console.log(this.honorIndex)
      if(this.honorIndex < (this.honorData.length-3)){
        this.honorIndex = this.honorIndex + 1
        let scrollLeft = this.$refs.honorCenter.scrollLeft
        let scrollTo = this.honorIndex*475
        console.log(scrollLeft)
        console.log(scrollTo)
        var timer = setInterval(()=>{
            if(scrollLeft < scrollTo){
              console.log(scrollLeft)
              scrollLeft = scrollLeft+10
              this.$refs.honorCenter.scrollLeft = scrollLeft
            }else{
              console.log('停止')
              clearInterval(timer)
            }
        },1);
      }else{
        console.log("最后一张")
      }
      
    },
  }
}
</script>
<style lang="scss" scoped>
.w{
    width: 1400px;
    margin:auto;
}
.honor{
    width: 100%;
    background: #f4f4f4;
    padding: 128px 0;
    // padding-bottom: 8px;
    overflow: hidden;
    // position: relative;
    .honorCenter::-webkit-scrollbar {
        display: none;
    }
    .honor_w{
        position: relative;
    }
    .iconLeft{
        width: 56px;
        height: 56px;
        // background: tan;
        position: absolute;
        top:40%;
        left:-150px;
        // z-index: 55;
    }   
    .iconRight{
        width: 56px;
        height: 56px;
        // background: tan;
        position: absolute;
        top:40%;
        right:-150px;
    }
    .honorCenter{
        width: 100%;
        height: 465px;
        padding-top: 56px;
        overflow-x: auto;
        // overflow-y: hidden;
        white-space: nowrap;
        // overflow-x:visible;
        background: #f4f4f4;
        // box-shadow: 0px 4px 8px rgba(12, 0, 51, 0.1);
        
        .li{
            width: 451px;
            height: 365px;
            background: #fff;
            display:inline-block;
            margin:24px;
            border-radius: 4px;
            overflow: hidden;
            box-shadow: 0px 8px 16px rgba(12, 0, 51, 0.1);
            .title{
                width: 92%;
                margin:0 auto;
                font-weight: bold;
                font-size: 17px;
                line-height: 44px;
                text-align: center;
                text-transform: capitalize;
                color: #000000;
            }
            .contentWord{
                width:92%;
                margin: 0 auto;
                white-space: pre-wrap;
                word-break: break-all;
                word-break: break-word;
                text-align: center;
                font-family: OPPOSans;
                font-size: 14px;
                line-height: 20px;
                color: rgba(0, 0, 0, 0.54);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/demo.vue